export const TIPO_TELEFONE = {
    
    CELULAR: "Celular",
    FIXO: "Fixo"    
}